module.exports = __webpack_public_path__ + "static/media/productos_home_otros.5be26dcd.jpg";